import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ConfirmPopup from '../ConfirmPopup';
import useApi from '../../hooks/useApi';
import { getImageUrl } from '../../utils';
import DeleteIcon from '../../icons/white-trash.svg';

import {
  DeleteButton,
  ContentEditorSection,
  Wrapper,
  FieldSet,
  FieldSetLabel,
  List,
  ListItem,
  ColumnWrapper,
  UserImage,
  UserName,
} from './styles';

const CollaboratorSection = ({
  options,
  fileService,
  flash,
  collaborators = [],
  setCollaborators,
  isSession,
  translations,
}) => {
  const { userToken, circle_id, inReview, ownerId } = options;

  const { deleteData } = useApi(userToken);

  const [removeCollaborator, setRemoveCollaborator] = useState({ popupIsOpen: false });

  const deleteCollaborator = async () => {
    const response = await deleteData(`/my-loops/${circle_id}/collaborator/${removeCollaborator?.id}`);
    if (response.success) {
      setCollaborators(collaborators.filter((collaborator) => collaborator?.User?.id !== removeCollaborator?.id));
      setRemoveCollaborator({ ...removeCollaborator, popupIsOpen: false });
    } else {
      console.error(response);
      if (response.message === 'auth_failed') {
        flash(i18n.__('app_error_unauthorized'), { ttl: 5000 });
      } else {
        flash(i18n.__('error_behavior_save_failed'));
      }
    }
  };

  const appTexts = translations.app;

  const collaboratorSorter = (a, b) => {
    const getKey = (item) => {
      const { full_name } = item.User || item;
      return `${item.id !== ownerId}_${full_name}`;
    };
    return getKey(a).localeCompare(getKey(b));
  };

  return (
    <ContentEditorSection>
      {!inReview && (
        <FieldSet>
          <FieldSetLabel>{isSession ? appTexts.teachers : appTexts.collaborators}</FieldSetLabel>
          <List>
            <ColumnWrapper>
              {collaborators.sort(collaboratorSorter).map((item) => {
                const { uuid, full_name, image, id } = item.User || item;
                const imageUrl = getImageUrl(fileService, image, '25x25');
                return (
                  <ListItem key={uuid || id}>
                    <Wrapper>
                      <UserImage src={imageUrl} />
                      <UserName>{full_name}</UserName>
                    </Wrapper>
                    {!isSession && item.id !== ownerId && (
                      <DeleteButton
                        src={DeleteIcon}
                        title={appTexts.remove}
                        onClick={() => setRemoveCollaborator({ popupIsOpen: true, id, full_name })}
                      />
                    )}
                  </ListItem>
                );
              })}
            </ColumnWrapper>
          </List>
        </FieldSet>
      )}
      <ConfirmPopup
        popupIsOpen={removeCollaborator.popupIsOpen}
        id="confirmRemoveCollaborator"
        title={`${i18n.__('remove_collaborator')} '${removeCollaborator?.full_name}'`}
        message={i18n.__('delete_confirm')}
        onCancel={() => setRemoveCollaborator({ ...removeCollaborator, popupIsOpen: false })}
        onConfirm={deleteCollaborator}
      />
    </ContentEditorSection>
  );
};

export default CollaboratorSection;

CollaboratorSection.propTypes = {
  options: PropTypes.object.isRequired,
  fileService: PropTypes.object.isRequired,
  flash: PropTypes.func.isRequired,
  setCollaborators: PropTypes.func.isRequired,
  collaborators: PropTypes.array.isRequired,
  isSession: PropTypes.bool.isRequired,
  translations: PropTypes.object.isRequired,
};
